import { TestTimeIndicator } from "../../services/utils/practice-test-util"

export enum SprintStatus {
    START = "START",
    RESUME = "RESUME",
    COMPLETED = "COMPLETED",
}

export interface IUserSprint {
    userId: string
    timedSprintId: string
    emailAddress: string
    subject: "english" | "math" | "reading" | "science" // Subject keys
    sprintNumber: number
    currentQuestionIndex: number
    remainingTimeInSeconds: number
    numberOfQuestions: number
    dateCreatedAt: string
    dateUpdatedAt: string
    testTimeIndicator: TestTimeIndicator
    answers: IUserSprintAnswer[]
}

export interface IUserSprintAnswer {
    questionNumber: number
    correctAnswer: string
    userSubmittedAnswer: string // May have "?" if flagged (bookmarked) first
    bookmarked: boolean
    correct: boolean
    studyTimeInSeconds: number
    updatedAt: string
}
